/** Shapes of `GET /diet/(coach/)sufficiency_trend`. All dates are IST `YYYY-MM-DD`. */

export type Granularity = 'daily' | 'weekly' | 'monthly';
export type Macro = 'protein' | 'carbs' | 'fats';
export const MACROS: Macro[] = ['protein', 'carbs', 'fats'];

export type DateRange = { from: string; to: string };

export type MacroAmount = { eaten: number; target: number | null };
export type MacroAmounts = Record<Macro, MacroAmount>;
export type MacroParts = Record<Macro, number>;

export interface SufficiencySummary {
  average_score: number | null;
  medal: boolean;
  days_planned: number;
  days_logged: number;
  medal_days: number;
  parts: MacroParts | null;
}

export interface SufficiencyBucket {
  from: string;
  to: string;
  partial: boolean;
  so_far: boolean;
  score: number | null;
  medal: boolean;
  days_planned: number;
  days_logged: number;
  medal_days: number;
  parts: MacroParts | null;
  macros: MacroAmounts | null;
}

export interface SufficiencyDay {
  date: string;
  has_plan: boolean;
  has_logs: boolean;
  score: number | null;
  medal: boolean;
  parts: MacroParts | null;
  macros: MacroAmounts | null;
}

export interface SufficiencyTrendPagination {
  page: number;
  total_pages: number;
  requested_from: string;
  requested_to: string;
}

export interface SufficiencyTrend {
  granularity: Granularity;
  from: string;
  to: string;
  today: string;
  medal_score: number;
  plan_window: { start: string; end: string } | null;
  summary: SufficiencySummary;
  macros: MacroAmounts | null;
  buckets: SufficiencyBucket[];
  days: SufficiencyDay[];
  pagination?: SufficiencyTrendPagination;
}
